<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import comSearch from './search/index.vue'

    export default {
        props: {
            value: [String, Number, Array],
            field: String,
            name: String,
            type: String,

            label: String,
            labelWidth: String,

            disabled: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                searchVisible: false,
            }
        },
        methods: {
            clear() {
                this.change_value();
            },
            search_open() {
                this.searchVisible = true;
            },
            search_close() {
                this.searchVisible = false;
            },
            search_change(v) {
                this.searchVisible = false;
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }

            },
            search_edit() {
                this.$router.push('/finances/certificates/edit/' + this.value);
            }
        },
        computed: {
            append() {
                return this.show_add || this.show_remove;
            },
            show_add() {
                if (this.disabled) return false;
                return this.add;
            },
            show_remove() {
                if (this.disabled) return false;
                if (!this.value) {
                    return false;
                }
                return true;
            },
            list() {
                let data = {};
                if (this.category) data.category = this.category;
                return this.items(data);
            },
        },
        watch: {},
        mounted() {

        },

        components: {comSearch,},
    }
</script>
<template>
    <form-group class="dictionary select-certificates" :label-width="labelWidth" :append="!disabled" :label="label">
        <el-input
                :value="name"
                :clearable="clearable"
                readonly
                :disabled="disabled">
        </el-input>
        <el-button
                v-if="show_remove"
                slot="append"
                icon="el-icon-close"
                title="Очистить"
                @click="search_change()">
        </el-button>
        <el-button
                v-if="show_add"
                slot="append"
                icon="el-icon-plus"
                title="Добавить"
                @click="item_add">
        </el-button>
        <el-button
                v-if="!disabled"
                slot="append"
                icon="el-icon-search"
                title="Поиск"
                @click="search_open">
        </el-button>
        <el-button
                v-if="name"
                slot="append"
                icon="el-icon-edit"
                title="Перейти в редактирование"
                @click="search_edit">
        </el-button>
        <com-search
                :type="type"
                :visible="searchVisible"
                @close="search_close"
                @change="search_change">
        </com-search>
    </form-group>
</template>
<style lang="scss">
    .select-certificates {

    }
</style>